<template>
  <fragment>
    <b-card :class="'main'">
      <h1>{{ $t('pages.faq.title') }}</h1>
      <p>{{ $t('pages.faq.body') }}</p>
    </b-card>
    <div role="tablist">
      <b-card
        no-body
        class="mb-1"
        v-for="(question, index) in $i18n.messages[$i18n.locale].pages.faq[
          `questions${comOnly ? 'ComOnly' : ''}`
        ]"
        :key="index"
      >
        <b-card-header header-tag="header" class="p-3" role="tab">
          <b-button block v-b-toggle="`q${index}`" variant="link"
            >{{ index + 1 }}. {{ question.title }}
          </b-button>
        </b-card-header>
        <b-collapse :id="`q${index}`" accordion="accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <i18n
                tag="p"
                :path="
                  `pages.faq['questions${
                    comOnly ? 'ComOnly' : ''
                  }'][${index}].body`
                "
              >
              </i18n>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </fragment>
</template>
<script>
export default {
  computed: {
    comOnly() {
      return this.$route.params['com_only'];
    },
  },
};
</script>
<style lang="scss" src="../../assets/scss/faq.scss" scoped />
